import { ajax, apicRoot } from '@liepin/js-core4c-fe';

export function loadUserInfoAjax(){
  return ajax({
    url: `${apicRoot}/api/com.liepin.usercx.pc.user.base-property`,
    method: 'post'
  }).then((data) => {
    const { data: userInfo } = data;
    window.CUserInfo = userInfo;
    return data;
  })
}